import { createApp } from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from "@/store/index"
import { i18n, setI18nLanguage } from '@/i18n'
import axios from '@/axios'
import Cookie from 'vue-cookie'

import "bootstrap/dist/css/bootstrap.min.css"
import "@/assets/css/main.scss";
import "bootstrap"

//make sure we can get languages before starting
axios.get('custom-content-page-lang/kitty-camper')
.then(response => {

	console.log(response.data);
	store.actions.setAvailableLangs( response.data.translations )

	//set default to en if no cookie found
	let activeLang = Cookie.get('locale');
	if (!activeLang) activeLang = 'en';

	response.data.translations.map(function(value) {
		if(value.lang == activeLang) setI18nLanguage( i18n, value);
	});

	const app = createApp(App)
	app.use(router)
	app.use(i18n)
	app.provide("store", store)
	app.mount('#app')

})
.catch(error=>{
	console.log(error);
})

